function filter (callback) {
  if (typeof callback === 'function') {
    return this.filterNodes(callback)
  } else if (typeof callback === 'string') { 
    return this.filterNodes(d => d.data.key !== callback);
  } else if (typeof callback === 'object' && callback.data) {
    return this.filterNodes(d => d.data.key !== callback.data.key);
  }
  return null;
}
export default function (callback) {
  let nodes;
  if (!arguments.length) { //모두 
    nodes = this.filterNodes().classed('mute', true).call(this.mute, this.muteIntensity());
  } else if (callback === null) { //모두 끄기
    nodes = this.filterNodes().classed('mute', false).call(this.demute);
  } else {
    nodes = filter.call(this, callback);
    if (nodes.size() > 0) {
      nodes.classed('mute', true).call(this.mute, this.muteIntensity());
    }
  }
  return this;
}

export {filter};


// WEBPACK FOOTER //
// ./layouts/default/muteNodes.js